export default __webpack_public_path__ + "static/4-6bfbb631b07cab9c6e8e8d1c1281457d.jpg";